import { Root } from '@radix-ui/react-dialog'
import type { ComponentPropsWithoutRef } from 'react'

type RootProps = ComponentPropsWithoutRef<typeof Root>

export interface SheetProps extends RootProps {
  defaultOpen?: RootProps['defaultOpen']
  open?: RootProps['open']
  onOpenChange?: RootProps['onOpenChange']
  modal?: RootProps['modal']
}

export const Sheet = (props: SheetProps) => {
  return <Root modal {...props} />
}
